import { useNavigate } from "react-router-dom";

import {
    MapPinIcon,
    CalendarIcon,
    UserIcon,
    MagnifyingGlassIcon,
    ChevronDownIcon,
} from "@heroicons/react/24/outline";

import { useState, useEffect } from "react";
import axios from "axios";

export default function SearchBar() {
    const [form, setForm] = useState({
        destination: "",
        checkIn: "",
        checkOut: "",
        guests: 1,
    });

    const navigate = useNavigate();

    const [destinations, setDestinations] = useState([]);



    // =========================================================
    // HANDLE FORM CHANGE
    // =========================================================

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    // =========================================================
    // HANDLE SUBMIT
    // =========================================================

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!form.destination.trim()) {
            alert("Please enter the destination");
            return;
        }

        navigate("/search-hotels", {
            state: form,
        });
    };



    // =========================================================
    // LOAD DESTINATIONS
    // =========================================================

    useEffect(() => {
        axios
            .get("https://beachhoteldubai.com/api/destinations")
            .then((res) => {
                setDestinations(res.data);
            })
            .catch((err) => console.log(err));
    }, []);



    // =========================================================
    // MAIN UI
    // =========================================================

    return (
        <div className="w-full">

            {/* =====================================================
                SEARCH CARD
            ===================================================== */}

            <div
                className="
                    overflow-hidden
                    rounded-[22px]
                    bg-white
                "
            >

                {/* =================================================
                    SEARCH FORM
                ================================================= */}

                <form
                    onSubmit={handleSubmit}
                    className="
                        flex
                        flex-col

                        lg:flex-row
                        lg:items-stretch
                    "
                >

                    {/* =================================================
                        DESTINATION
                    ================================================= */}

                    <div
                        className="
                            group
                            relative
                            min-w-0
                            flex-1

                            px-5
                            py-5

                            transition-all
                            duration-300

                            hover:bg-[#F8FBFD]
                            focus-within:bg-[#F8FBFD]

                            lg:px-6
                            lg:py-5
                        "
                    >
                        <div
                            className="
                                mb-2
                                flex
                                items-center
                                gap-2
                            "
                        >
                            <span
                                className="
                                    flex
                                    h-8
                                    w-8
                                    shrink-0
                                    items-center
                                    justify-center
                                    rounded-full
                                    bg-[#EEF5FF]
                                "
                            >
                                <MapPinIcon
                                    className="
                                        h-[17px]
                                        w-[17px]
                                        text-[#174EA6]
                                    "
                                    strokeWidth={1.8}
                                />
                            </span>

                            <span
                                className="
                                    text-[10px]
                                    font-bold
                                    uppercase
                                    tracking-[0.12em]
                                    text-[#64747D]
                                "
                            >
                                Destination
                            </span>
                        </div>

                        <div className="relative pl-10">
                            <select
                                name="destination"
                                value={form.destination}
                                onChange={handleChange}
                                className="
                                    w-full
                                    appearance-none
                                    bg-transparent
                                    pr-8
                                    text-[14px]
                                    font-semibold
                                    text-[#123F42]
                                    outline-none
                                    cursor-pointer
                                "
                            >
                                <option value="">
                                    Where are you going?
                                </option>

                                {destinations.map((dest) => (
                                    <option
                                        key={dest.id}
                                        value={dest.name}
                                    >
                                        {dest.name}
                                    </option>
                                ))}
                            </select>

                            <ChevronDownIcon
                                className="
                                    pointer-events-none
                                    absolute
                                    right-0
                                    top-1/2
                                    h-4
                                    w-4
                                    -translate-y-1/2
                                    text-[#174EA6]
                                "
                                strokeWidth={1.8}
                            />
                        </div>
                    </div>

                    {/* =================================================
                        CHECK IN
                    ================================================= */}

                    <div
                        className="
                            group
                            relative
                            min-w-0
                            flex-1

                            border-t
                            border-[#E7EDF1]

                            px-5
                            py-5

                            transition-all
                            duration-300

                            hover:bg-[#F8FBFD]
                            focus-within:bg-[#F8FBFD]

                            lg:border-l
                            lg:border-t-0
                            lg:border-[#E7EDF1]

                            lg:px-6
                            lg:py-5
                        "
                    >
                        <div
                            className="
                                mb-2
                                flex
                                items-center
                                gap-2
                            "
                        >
                            <span
                                className="
                                    flex
                                    h-8
                                    w-8
                                    shrink-0
                                    items-center
                                    justify-center
                                    rounded-full
                                    bg-[#EEF5FF]
                                "
                            >
                                <CalendarIcon
                                    className="
                                        h-[17px]
                                        w-[17px]
                                        text-[#174EA6]
                                    "
                                    strokeWidth={1.8}
                                />
                            </span>

                            <span
                                className="
                                    text-[10px]
                                    font-bold
                                    uppercase
                                    tracking-[0.12em]
                                    text-[#64747D]
                                "
                            >
                                Check In
                            </span>
                        </div>

                        <div className="relative pl-10">
                            <input
                                type="date"
                                name="checkIn"
                                value={form.checkIn}
                                onChange={handleChange}
                                className="
                                    w-full
                                    bg-transparent
                                    text-[14px]
                                    font-semibold
                                    text-[#123F42]
                                    outline-none
                                    cursor-pointer

                                    [&::-webkit-calendar-picker-indicator]:opacity-0
                                    [&::-webkit-calendar-picker-indicator]:absolute
                                    [&::-webkit-calendar-picker-indicator]:right-0
                                    [&::-webkit-calendar-picker-indicator]:w-full
                                    [&::-webkit-calendar-picker-indicator]:h-full
                                    [&::-webkit-calendar-picker-indicator]:cursor-pointer
                                "
                            />


                        </div>
                    </div>

                    {/* =================================================
                        CHECK OUT
                    ================================================= */}

                    <div
                        className="
                            group
                            relative
                            min-w-0
                            flex-1

                            border-t
                            border-[#E7EDF1]

                            px-5
                            py-5

                            transition-all
                            duration-300

                            hover:bg-[#F8FBFD]
                            focus-within:bg-[#F8FBFD]

                            lg:border-l
                            lg:border-t-0
                            lg:border-[#E7EDF1]

                            lg:px-6
                            lg:py-5
                        "
                    >
                        <div
                            className="
                                mb-2
                                flex
                                items-center
                                gap-2
                            "
                        >
                            <span
                                className="
                                    flex
                                    h-8
                                    w-8
                                    shrink-0
                                    items-center
                                    justify-center
                                    rounded-full
                                    bg-[#EEF5FF]
                                "
                            >
                                <CalendarIcon
                                    className="
                                        h-[17px]
                                        w-[17px]
                                        text-[#174EA6]
                                    "
                                    strokeWidth={1.8}
                                />
                            </span>

                            <span
                                className="
                                    text-[10px]
                                    font-bold
                                    uppercase
                                    tracking-[0.12em]
                                    text-[#64747D]
                                "
                            >
                                Check Out
                            </span>
                        </div>

                        <div className="relative pl-10">
                            <input
                                type="date"
                                name="checkOut"
                                value={form.checkOut}
                                onChange={handleChange}
                                className="
                                    w-full
                                    bg-transparent
                                    text-[14px]
                                    font-semibold
                                    text-[#123F42]
                                    outline-none
                                    cursor-pointer

                                    [&::-webkit-calendar-picker-indicator]:opacity-0
                                    [&::-webkit-calendar-picker-indicator]:absolute
                                    [&::-webkit-calendar-picker-indicator]:right-0
                                    [&::-webkit-calendar-picker-indicator]:w-full
                                    [&::-webkit-calendar-picker-indicator]:h-full
                                    [&::-webkit-calendar-picker-indicator]:cursor-pointer
                                "
                            />


                        </div>
                    </div>

                    {/* =================================================
                        GUESTS
                    ================================================= */}

                    <div
                        className="
                            group
                            relative
                            min-w-0
                            flex-1

                            border-t
                            border-[#E7EDF1]

                            px-5
                            py-5

                            transition-all
                            duration-300

                            hover:bg-[#F8FBFD]
                            focus-within:bg-[#F8FBFD]

                            lg:border-l
                            lg:border-t-0
                            lg:border-[#E7EDF1]

                            lg:px-6
                            lg:py-5
                        "
                    >
                        <div
                            className="
                                mb-2
                                flex
                                items-center
                                gap-2
                            "
                        >
                            <span
                                className="
                                    flex
                                    h-8
                                    w-8
                                    shrink-0
                                    items-center
                                    justify-center
                                    rounded-full
                                    bg-[#EEF5FF]
                                "
                            >
                                <UserIcon
                                    className="
                                        h-[17px]
                                        w-[17px]
                                        text-[#174EA6]
                                    "
                                    strokeWidth={1.8}
                                />
                            </span>

                            <span
                                className="
                                    text-[10px]
                                    font-bold
                                    uppercase
                                    tracking-[0.12em]
                                    text-[#64747D]
                                "
                            >
                                Guests
                            </span>
                        </div>

                        <div className="relative pl-10">
                            <select
                                name="guests"
                                value={form.guests}
                                onChange={handleChange}
                                className="
                                    w-full
                                    appearance-none
                                    bg-transparent
                                    pr-8
                                    text-[14px]
                                    font-semibold
                                    text-[#123F42]
                                    outline-none
                                    cursor-pointer
                                "
                            >
                                {[1, 2, 3, 4, 5, 6].map(
                                    (num) => (
                                        <option
                                            key={num}
                                            value={num}
                                        >
                                            {num}{" "}
                                            {num === 1
                                                ? "Guest"
                                                : "Guests"}
                                        </option>
                                    )
                                )}
                            </select>

                            <ChevronDownIcon
                                className="
                                    pointer-events-none
                                    absolute
                                    right-0
                                    top-1/2
                                    h-4
                                    w-4
                                    -translate-y-1/2
                                    text-[#174EA6]
                                "
                                strokeWidth={1.8}
                            />
                        </div>
                    </div>

                    {/* =================================================
                        SEARCH BUTTON
                    ================================================= */}

                    <div
                        className="
        flex
        w-full
        items-center
        justify-center
        p-2

        lg:w-auto
        lg:min-w-[175px]
        lg:p-2
    "
                    >
                        <button
                            type="submit"
                            className="
            group
            flex
            h-[48px]
            w-auto
            min-w-[155px]
            items-center
            justify-center
            gap-2

            rounded-[15px]

            bg-[#FFD54F]

            px-6

            text-[13px]
            font-bold
            text-[#0B5552]

            shadow-[0_7px_20px_rgba(255,201,40,0.25)]

            transition-all
            duration-300

            hover:-translate-y-0.5
            hover:bg-[#8B0000]
            hover:text-white
            hover:shadow-[0_10px_25px_rgba(255,201,40,0.35)]

            active:translate-y-0
            active:scale-[0.98]

            whitespace-nowrap
        "
                        >
                            <MagnifyingGlassIcon
                                className="
                h-[19px]
                w-[19px]
                transition-transform
                duration-300
                group-hover:scale-110
            "
                                strokeWidth={2}
                            />

                            <span>
                                Search Hotels
                            </span>
                        </button>
                    </div>
                </form>


            </div>
        </div>
    );
}

